// import React from 'react';
// import {
//     Card,
//     Form,
//     Input,
//     Button,
//     Modal,
//     Descriptions,
//     Tag,
//     Alert,
//     Badge,
//     Typography,
//     Row,
//     Col,
//     Space
// } from 'antd';
// import {
//     SearchOutlined,
//     ClockCircleOutlined,
//     CheckCircleOutlined,
//     CloseCircleOutlined,
//     ExclamationCircleOutlined,
//     PhoneOutlined,
//     DownloadOutlined,
//     PrinterOutlined
// } from '@ant-design/icons';

// const { Text } = Typography;

// const StatusBadge = ({ status }) => {
//     const statusConfig = {
//         pending: { color: 'orange', text: 'Under Review', icon: <ClockCircleOutlined /> },
//         approved: { color: 'green', text: 'Approved', icon: <CheckCircleOutlined /> },
//         rejected: { color: 'red', text: 'Rejected', icon: <CloseCircleOutlined /> },
//         'needs-correction': { color: 'gold', text: 'Correction Required', icon: <ExclamationCircleOutlined /> },
//         submitted: { color: 'blue', text: 'Submitted', icon: <ClockCircleOutlined /> }
//     };

//     const config = statusConfig[status] || { color: 'default', text: status, icon: null };

//     return (
//         <Badge
//             status={config.color}
//             text={
//                 <span style={{ fontWeight: 500 }}>
//                     {config.icon} {config.text}
//                 </span>
//             }
//         />
//     );
// };

// const StatusCheckModal = ({
//     open,
//     onClose,
//     statusData,
//     onSearch,
//     searchLoading,
//     form,
//     searchAttempted
// }) => (
//     //console.log(searchAttempted),
//     //console.log('Status Data:', statusData),
//     <Modal
//         title={
//             <div style={{ textAlign: 'center', padding: '8px 0' }}>
//                 <Text strong style={{ fontSize: '20px', color: '#1890ff' }}>
//                     Media Request Status
//                 </Text>
//             </div>
//         }
//         open={open}
//         onCancel={onClose}
//         footer={null}
//         width={550}
//         style={{ marginTop: "180px" }}
//         centered
//         styles={{
//             body: {
//                 padding: '0',

//             }
//         }}
//     >
//         <div style={{ padding: "0" }}>
//             {/* Search Section */}
//             <Card
//                 style={{
//                     marginBottom: 14,
//                     border: 'none',
//                     boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//                 }}
//                 bodyStyle={{
//                     padding: "24px"
//                 }}
//             >


//                 <div style={{ textAlign: 'center', marginBottom: 10 }}>
//                     <Text type="secondary" style={{ fontSize: '14px' }}>
//                         Enter your registered mobile number to track your media request
//                     </Text>
//                 </div>
//                 <Form
//                     layout="vertical"
//                     onFinish={onSearch}
//                     form={form}
//                 >
//                     <Row gutter={12} align="bottom">
//                         <Col xs={24} sm={16} md={18}>
//                             <Form.Item
//                                 label="Mobile Number"
//                                 name="mobileNumber"
//                                 style={{ marginBottom: 0 }}
//                                 rules={[
//                                     { required: true, message: 'Please enter your mobile number' },
//                                     { pattern: /^[0-9]{10}$/, message: 'Please enter valid 10-digit number' }
//                                 ]}
//                             >
//                                 <Input
//                                     placeholder="Enter your 10-digit mobile number"
//                                     size="large"
//                                     style={{
//                                         borderRadius: '8px',
//                                         height: '48px'
//                                     }}
//                                 />
//                             </Form.Item>
//                         </Col>
//                         <Col xs={24} sm={8} md={6}>
//                             <Form.Item style={{ marginBottom: 0 }}>
//                                 <Button
//                                     type="primary"
//                                     htmlType="submit"
//                                     loading={searchLoading}
//                                     size="large"
//                                     icon={<SearchOutlined />}
//                                     style={{
//                                         width: '100%',
//                                         height: '33px', // Fixed height to match input
//                                         borderRadius: '8px',
//                                         background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
//                                         border: 'none',
//                                         fontWeight: '600',
//                                         fontSize: '14px',
//                                         marginBottom: "10px"
//                                     }}
//                                 >
//                                     Search
//                                 </Button>
//                             </Form.Item>
//                         </Col>
//                     </Row>


//                     {searchAttempted && statusData === null && (
//                         <Alert
//                             message="No Application Found"
//                             description="We couldn't find any media application with this mobile number. Please check the number and try again."
//                             type="error"
//                             showIcon
//                             style={{
//                                 marginTop: 16,
//                                 borderRadius: '8px',
//                                 border: '1px solid #ffccc7',
//                                 background: '#fff2f0'
//                             }}
//                         />
//                     )}
//                 </Form>
//             </Card>

//             {/* Status Display Section */}
//             {statusData && (
//                 <Card
//                     style={{
//                         border: 'none',
//                         boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
//                     }}
//                     bodyStyle={{ padding: 0 }}
//                 >
//                     <div style={{ padding: '20px 24px 0 24px' }}>
//                         <Text strong style={{ fontSize: '18px', color: '#262626' }}>
//                             Application Details
//                         </Text>
//                     </div>

//                     <Descriptions
//                         bordered
//                         column={1}
//                         size="middle"
//                         style={{
//                             padding: 16,
//                             marginTop: 8
//                         }}
//                         labelStyle={{
//                             fontWeight: '600',
//                             background: '#fafafa',
//                             width: '140px'
//                         }}
//                         contentStyle={{
//                             background: '#fff'
//                         }}
//                     >
//                         <Descriptions.Item label="Request ID">
//                             <Tag
//                                 color="blue"
//                                 style={{
//                                     fontSize: '12px',
//                                     padding: '4px 8px',
//                                     borderRadius: '4px',
//                                     fontWeight: '500'
//                                 }}
//                             >
//                                 MEDIA#{statusData.requestId ? statusData.requestId.slice(-6).toUpperCase() : 'N/A'}
//                             </Tag>
//                         </Descriptions.Item>
//                         <Descriptions.Item label="Full Name">
//                             <Text strong>{statusData.fullName}</Text>
//                         </Descriptions.Item>
//                         <Descriptions.Item label="Media House">
//                             {statusData.mediaHouseName}
//                         </Descriptions.Item>
//                         <Descriptions.Item label="Media Type">
//                             <Tag
//                                 style={{
//                                     borderRadius: '4px',
//                                     border: '1px solid #d9d9d9',
//                                     background: '#f5f5f5'
//                                 }}
//                             >
//                                 {statusData.mediaType}
//                             </Tag>
//                         </Descriptions.Item>
//                         <Descriptions.Item label="Submission Date">
//                             {new Date(statusData.submittedAt).toLocaleDateString('en-IN', {
//                                 day: '2-digit',
//                                 month: '2-digit',
//                                 year: 'numeric',
//                                 hour: '2-digit',
//                                 minute: '2-digit'
//                             })}
//                         </Descriptions.Item>
//                         <Descriptions.Item label="Current Status">
//                             {statusData.status === 'rejected' ? (
//                                 <span style={{ color: '#ff4d4f', fontWeight: 500 }}>
//                                     Not Approved
//                                 </span>
//                             ) : (
//                                 <StatusBadge status={statusData.status} />
//                             )}
//                         </Descriptions.Item>
//                         {/* {statusData.remarks && (
//                             <Descriptions.Item label="Admin Remarks">
//                                 <Alert
//                                     message={
//                                         statusData.status === 'approved'
//                                             ? 'Your request is approved. Collect your gatepass from khasdar samiti office.'
//                                             : statusData.status === 'rejected'
//                                                 ? 'Not Approved'
//                                                 : statusData.remarks
//                                     }
//                                     type={
//                                         statusData.status === 'approved'
//                                             ? 'success'
//                                             : statusData.status === 'rejected'
//                                                 ? 'error'
//                                                 : 'info'
//                                     }
//                                     showIcon
//                                     style={{
//                                         marginTop: 8,
//                                         borderRadius: '6px'
//                                     }}
//                                 />
//                             </Descriptions.Item>
//                         )} */}

//                         {

//                             statusData.remarks && (
//                                 <Descriptions.Item label="Admin Remarks">


//                                     {statusData.status === 'approved' && (
//                                         <div style={{ marginTop: '16px' }}>
//                                             <button
//                                                 onClick={() => {
//                                                     // Add your download logic here

//                                                     // For example: window.open('/api/download-gatepass/' + statusData.id, '_blank');
//                                                     console.log('Download gatepass');
//                                                 }}
//                                                 style={{
//                                                     backgroundColor: '#52c41a',
//                                                     color: 'white',
//                                                     border: 'none',
//                                                     padding: '10px 20px',
//                                                     borderRadius: '6px',
//                                                     fontSize: '14px',
//                                                     fontWeight: '600',
//                                                     cursor: 'pointer',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     gap: '8px',
//                                                     transition: 'background-color 0.3s ease',
//                                                 }}
//                                                 onMouseEnter={(e) => {
//                                                     e.currentTarget.style.backgroundColor = '#73d13d';
//                                                 }}
//                                                 onMouseLeave={(e) => {
//                                                     e.currentTarget.style.backgroundColor = '#52c41a';
//                                                 }}
//                                             >
//                                                 <DownloadOutlined />
//                                                 Download Your Gatepass
//                                             </button>

//                                             <div style={{
//                                                 marginTop: '12px',
//                                                 padding: '12px 16px',
//                                                 backgroundColor: '#fff1f0',
//                                                 border: '1px solid #ffccc7',
//                                                 borderRadius: '6px',
//                                                 fontSize: '13px',
//                                                 color: '#cf1322',
//                                                 lineHeight: '1.6'
//                                             }}>
//                                                 <strong style={{ display: 'block', marginBottom: '6px' }}>⚠️ Important Note:</strong>
//                                                 <ul style={{
//                                                     margin: 0,
//                                                     paddingLeft: '20px',
//                                                     listStyleType: 'disc'
//                                                 }}>
//                                                     <li style={{ display: 'list-item' }}>Do not share or transfer your gatepass to anyone.</li>
//                                                     <li style={{ display: 'list-item' }}>Bring your gatepass to the event for entry.</li>
//                                                 </ul>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </Descriptions.Item>
//                             )}
//                     </Descriptions>


//                 </Card>
//             )}


//             {/* Help Text */}
//             {!statusData && statusData !== null && (
//                 <div style={{
//                     textAlign: 'center',
//                     padding: '16px',
//                     background: '#f6ffed',
//                     borderRadius: '6px',
//                     border: '1px solid #b7eb8f',
//                     marginTop: '16px'
//                 }}>
//                     <Text type="secondary" style={{ fontSize: '14px' }}>
//                         💡 Enter your registered mobile number to check your media accreditation status
//                     </Text>
//                 </div>
//             )}
//         </div>
//     </Modal>
// );

// export default StatusCheckModal;





import React from 'react';
import {
    Card,
    Form,
    Input,
    Button,
    Modal,
    Descriptions,
    Tag,
    Alert,
    Badge,
    Typography,
    Row,
    Col,
    Space,
    message
} from 'antd';
import {
    SearchOutlined,
    ClockCircleOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    ExclamationCircleOutlined,
    PhoneOutlined,
    DownloadOutlined,
    PrinterOutlined
} from '@ant-design/icons';

const { Text } = Typography;

const StatusBadge = ({ status }) => {
    const statusConfig = {
        pending: { color: 'orange', text: 'Under Review', icon: <ClockCircleOutlined /> },
        approved: { color: 'green', text: 'Approved', icon: <CheckCircleOutlined /> },
        rejected: { color: 'red', text: 'Rejected', icon: <CloseCircleOutlined /> },
        'needs-correction': { color: 'gold', text: 'Correction Required', icon: <ExclamationCircleOutlined /> },
        submitted: { color: 'blue', text: 'Submitted', icon: <ClockCircleOutlined /> }
    };

    const config = statusConfig[status] || { color: 'default', text: status, icon: null };

    return (
        <Badge
            status={config.color}
            text={
                <span style={{ fontWeight: 500 }}>
                    {config.icon} {config.text}
                </span>
            }
        />
    );
};

const StatusCheckModal = ({
    open,
    onClose,
    statusData,
    onSearch,
    searchLoading,
    form,
    searchAttempted,
    generatePDFGatePass // Add this as a prop
}) => {

    // Helper function to format name
    const formatName = (name) => {
        return name.replace(/\s+/g, '_').toLowerCase();
    };

    // Function to generate gate pass
    // Function to generate gate pass
    const generateGatePass = async (record) => {
        try {
            message.loading('Generating gate pass...', 0);

            // Check if QR code exists
            if (!record.qrCodeLink) {
                message.destroy();
                message.error("Gatepass not available. Please contact admin.");
                return;
            }

            // Determine pass type based on mediaType
            let passType = record.mediaType || 'Media';

            // If it's Press type, use the pressType value
            if (record.mediaType === "Press" && record.pressType) {
                passType = record.pressType; // Will be "Print Media" or "Electronic Media"
            }

            // Prepare data for gate pass
            const gatePassData = {
                name: record.fullName,
                mediaHouse: record.mediaHouseName || 'N/A',
                passType: passType, // This determines what shows on the gate pass
                eventName: 'KHASDAR MAHOTSAV',
                eventDate: 'November 07-18, 2025',
                eventVenue: 'Civil Lines, Nagpur',
                photographerName: record.photographerName || '',
                cameramanName: record.cameramanName || '',
                validUntil: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString('en-IN'),
                passId: record.requestId || `MEDIA-${Math.random().toString(36).substr(2, 9).toUpperCase()}`,
                qrCodeLink: record.qrCodeLink
            };

            //console.log('Generating gate pass with data:', gatePassData); // Debug log

            const fileName = `${formatName(record.fullName)}_MediaPass_${Date.now()}.pdf`;

            // Call the PDF generation function passed as prop
            await generatePDFGatePass(gatePassData, fileName);

            message.destroy();
            message.success("Gate pass downloaded successfully!");

        } catch (error) {
            console.error('Error generating gate pass:', error);
            message.destroy();
            message.error(`Failed to generate gate pass: ${error.message}`);
        }
    };

    return (
        <Modal
            title={
                <div style={{ textAlign: 'center', padding: '8px 0' }}>
                    <Text strong style={{ fontSize: '20px', color: '#1890ff' }}>
                        Media Request Status
                    </Text>
                </div>
            }
            open={open}
            onCancel={onClose}
            footer={null}
            width={550}
            style={{ marginTop: "180px" }}
            centered
            styles={{
                body: {
                    padding: '0',
                }
            }}
        >
            <div style={{ padding: "0" }}>
                {/* Search Section */}
                <Card
                    style={{
                        marginBottom: 14,
                        border: 'none',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }}
                    bodyStyle={{
                        padding: "24px"
                    }}
                >
                    <div style={{ textAlign: 'center', marginBottom: 10 }}>
                        <Text type="secondary" style={{ fontSize: '14px' }}>
                            Enter your registered mobile number to track your media request
                        </Text>
                    </div>
                    <Form
                        layout="vertical"
                        onFinish={onSearch}
                        form={form}
                    >
                        <Row gutter={12} align="bottom">
                            <Col xs={24} sm={16} md={18}>
                                <Form.Item
                                    label="Mobile Number"
                                    name="mobileNumber"
                                    style={{ marginBottom: 0 }}
                                    rules={[
                                        { required: true, message: 'Please enter your mobile number' },
                                        { pattern: /^[0-9]{10}$/, message: 'Please enter valid 10-digit number' }
                                    ]}
                                >
                                    <Input
                                        placeholder="Enter your 10-digit mobile number"
                                        size="large"
                                        style={{
                                            borderRadius: '8px',
                                            height: '48px'
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={8} md={6}>
                                <Form.Item style={{ marginBottom: 0 }}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        loading={searchLoading}
                                        size="large"
                                        icon={<SearchOutlined />}
                                        style={{
                                            width: '100%',
                                            height: '33px',
                                            borderRadius: '8px',
                                            background: 'linear-gradient(135deg, #1890ff 0%, #096dd9 100%)',
                                            border: 'none',
                                            fontWeight: '600',
                                            fontSize: '14px',
                                            marginBottom: "10px"
                                        }}
                                    >
                                        Search
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>

                        {searchAttempted && statusData === null && (
                            <Alert
                                message="No Application Found"
                                description="We couldn't find any media application with this mobile number. Please check the number and try again."
                                type="error"
                                showIcon
                                style={{
                                    marginTop: 16,
                                    borderRadius: '8px',
                                    border: '1px solid #ffccc7',
                                    background: '#fff2f0'
                                }}
                            />
                        )}
                    </Form>
                </Card>

                {/* Status Display Section */}
                {statusData && (
                    <Card
                        style={{
                            border: 'none',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                        }}
                        bodyStyle={{ padding: 0 }}
                    >
                        <div style={{ padding: '20px 24px 0 24px' }}>
                            <Text strong style={{ fontSize: '18px', color: '#262626' }}>
                                Application Details
                            </Text>
                        </div>

                        <Descriptions
                            bordered
                            column={1}
                            size="middle"
                            style={{
                                padding: 16,
                                marginTop: 8
                            }}
                            labelStyle={{
                                fontWeight: '600',
                                background: '#fafafa',
                                width: '140px'
                            }}
                            contentStyle={{
                                background: '#fff'
                            }}
                        >
                            <Descriptions.Item label="Request ID">
                                <Tag
                                    color="blue"
                                    style={{
                                        fontSize: '12px',
                                        padding: '4px 8px',
                                        borderRadius: '4px',
                                        fontWeight: '500'
                                    }}
                                >
                                    MEDIA#{statusData.requestId ? statusData.requestId.slice(-6).toUpperCase() : 'N/A'}
                                </Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label="Full Name">
                                <Text strong>{statusData.fullName}</Text>
                            </Descriptions.Item>
                            <Descriptions.Item label="Media House">
                                {statusData.mediaHouseName}
                            </Descriptions.Item>
                            <Descriptions.Item label="Media Type">
                                <Tag
                                    style={{
                                        borderRadius: '4px',
                                        border: '1px solid #d9d9d9',
                                        background: '#f5f5f5'
                                    }}
                                >
                                    {statusData.mediaType}
                                </Tag>
                            </Descriptions.Item>
                            <Descriptions.Item label="Submission Date">
                                {new Date(statusData.submittedAt).toLocaleDateString('en-IN', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })}
                            </Descriptions.Item>
                            <Descriptions.Item label="Current Status">
                                {statusData.status === 'rejected' ? (
                                    <span style={{ color: '#ff4d4f', fontWeight: 500 }}>
                                        Not Approved
                                    </span>
                                ) : (
                                    <StatusBadge status={statusData.status} />
                                )}
                            </Descriptions.Item>

                            {statusData.remarks && statusData.status === 'approved' && (
                                <Descriptions.Item label="Admin Remarks">
                                    <div style={{ marginTop: '16px' }}>
                                        <button
                                            onClick={() => generateGatePass(statusData)}
                                            style={{
                                                backgroundColor: '#52c41a',
                                                color: 'white',
                                                border: 'none',
                                                padding: '10px 20px',
                                                borderRadius: '6px',
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                transition: 'background-color 0.3s ease',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = '#73d13d';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#52c41a';
                                            }}
                                        >
                                            <DownloadOutlined />
                                            Download Your Gatepass
                                        </button>
                                        <div style={{
                                            marginTop: '12px',
                                            padding: '12px 16px',
                                            backgroundColor: '#fff1f0',
                                            border: '1px solid #ffccc7',
                                            borderRadius: '6px',
                                            fontSize: '13px',
                                            lineHeight: '1.6'
                                        }}>
                                            <strong style={{ display: 'block', marginBottom: '6px', color: '#cf1322' }}>⚠️ Important Note:</strong>
                                            <div style={{ color: 'black' }}>
                                                <div style={{ marginBottom: '8px' }}>
                                                    <strong>1.</strong> Gatepass are non-transferable.
                                                </div>
                                                <div>
                                                    <strong>2.</strong> Please be early to ensure smooth entry. 
                                                </div>
                                                <div>
                                                    <strong>2.</strong> Carry your press ID along with the gatepass for entry verification.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Descriptions.Item>
                            )}
                        </Descriptions>
                    </Card>
                )}

                {/* Help Text */}
                {!statusData && statusData !== null && (
                    <div style={{
                        textAlign: 'center',
                        padding: '16px',
                        background: '#f6ffed',
                        borderRadius: '6px',
                        border: '1px solid #b7eb8f',
                        marginTop: '16px'
                    }}>
                        <Text type="secondary" style={{ fontSize: '14px' }}>
                            💡 Enter your registered mobile number to check your media accreditation status
                        </Text>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default StatusCheckModal;